import { render, staticRenderFns } from "./PreferredLocation.vue?vue&type=template&id=116b5248&scoped=true&"
import script from "./PreferredLocation.vue?vue&type=script&lang=js&"
export * from "./PreferredLocation.vue?vue&type=script&lang=js&"
import style0 from "./PreferredLocation.vue?vue&type=style&index=0&id=116b5248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116b5248",
  null
  
)

export default component.exports